import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Card } from '@codametrix/ui-components';
import { objectUtils, appServiceLines } from '@codametrix/ui-common';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
const ServiceLineMessage = ()=>{
    const { serviceLine } = useSelector((state)=>state.ui);
    const dispatch = useDispatch();
    const history = useHistory();
    const path = history.location.pathname;
    const actionGroups = useSelector((state)=>state.ui.actionGroups);
    const activeActionGroupKey = actionGroups.find((ag)=>ag.options[0].active === true)?.key;
    useEffect(()=>{
        if (serviceLine) {
            const serviceLinePath = appServiceLines.toServiceLineSlug(serviceLine.name);
            const expectedPath = `${path}${serviceLinePath}/`;
            // Only navigate if the current path doesn't already end with the service line
            // This prevents the infinite loop when navigation updates the path
            if (!path.endsWith(`${serviceLinePath}/`)) {
                // Use replace so `/cmx/cases/` is not left as its own session entry. Otherwise
                // browser Back from a case can land on the bare `/cmx/cases/` step (or skip the
                // grid) and feel like leaving the Cases experience.
                history.replace(expectedPath);
            }
        }
    // Only re-run when serviceLine.name or path actually changes, not when serviceLine object reference changes
    }, [
        serviceLine?.name,
        dispatch,
        path
    ]);
    if (!serviceLine) {
        return /*#__PURE__*/ _jsxs(Card, {
            className: 'content-vacant qa-service-line-message',
            children: [
                /*#__PURE__*/ _jsx("h2", {
                    children: /*#__PURE__*/ _jsx("b", {
                        children: "No service line available"
                    })
                }),
                /*#__PURE__*/ _jsxs("h4", {
                    children: [
                        objectUtils.startCase(activeActionGroupKey),
                        " requires a service line. Please contact an administrator to add one."
                    ]
                }),
                /*#__PURE__*/ _jsx("p", {
                    children: " support@codametrix.com "
                }),
                ' '
            ]
        });
    } else {
        return /*#__PURE__*/ _jsx("div", {
            className: 'qa-empty-service-line-message',
            "data-testid": "empty-service-line-message"
        });
    }
};
export default ServiceLineMessage;
